/**
 * Polskie święta państwowe — hardcoded dla 2025-2030.
 * Migracja do biblioteki `date-holidays` planowana w M7+ (dla MVP wystarczy).
 * Daty w formacie YYYY-MM-DD (lokalny czas Europe/Warsaw == UTC midnight w @db.Date).
 *
 * Współdzielone między backendem (calculateWorkingDays w endpointach vacation)
 * a frontendem (preview workingDays + lista świąt w vacation-request-dialog).
 */
const POLISH_HOLIDAYS = {
    2025: [
        { date: '2025-01-01', name: 'Nowy Rok' },
        { date: '2025-01-06', name: 'Trzech Króli' },
        { date: '2025-04-20', name: 'Wielkanoc' },
        { date: '2025-04-21', name: 'Poniedziałek Wielkanocny' },
        { date: '2025-05-01', name: 'Święto Pracy' },
        { date: '2025-05-03', name: 'Konstytucji 3 Maja' },
        { date: '2025-06-08', name: 'Zesłanie Ducha Świętego' },
        { date: '2025-06-19', name: 'Boże Ciało' },
        { date: '2025-08-15', name: 'Wniebowzięcie NMP' },
        { date: '2025-11-01', name: 'Wszystkich Świętych' },
        { date: '2025-11-11', name: 'Święto Niepodległości' },
        { date: '2025-12-24', name: 'Wigilia Bożego Narodzenia' },
        { date: '2025-12-25', name: 'Boże Narodzenie' },
        { date: '2025-12-26', name: 'Drugi dzień Bożego Narodzenia' },
    ],
    2026: [
        { date: '2026-01-01', name: 'Nowy Rok' },
        { date: '2026-01-06', name: 'Trzech Króli' },
        { date: '2026-04-05', name: 'Wielkanoc' },
        { date: '2026-04-06', name: 'Poniedziałek Wielkanocny' },
        { date: '2026-05-01', name: 'Święto Pracy' },
        { date: '2026-05-03', name: 'Konstytucji 3 Maja' },
        { date: '2026-05-24', name: 'Zesłanie Ducha Świętego' },
        { date: '2026-06-04', name: 'Boże Ciało' },
        { date: '2026-08-15', name: 'Wniebowzięcie NMP' },
        { date: '2026-11-01', name: 'Wszystkich Świętych' },
        { date: '2026-11-11', name: 'Święto Niepodległości' },
        { date: '2026-12-24', name: 'Wigilia Bożego Narodzenia' },
        { date: '2026-12-25', name: 'Boże Narodzenie' },
        { date: '2026-12-26', name: 'Drugi dzień Bożego Narodzenia' },
    ],
    2027: [
        { date: '2027-01-01', name: 'Nowy Rok' },
        { date: '2027-01-06', name: 'Trzech Króli' },
        { date: '2027-03-28', name: 'Wielkanoc' },
        { date: '2027-03-29', name: 'Poniedziałek Wielkanocny' },
        { date: '2027-05-01', name: 'Święto Pracy' },
        { date: '2027-05-03', name: 'Konstytucji 3 Maja' },
        { date: '2027-05-16', name: 'Zesłanie Ducha Świętego' },
        { date: '2027-05-27', name: 'Boże Ciało' },
        { date: '2027-08-15', name: 'Wniebowzięcie NMP' },
        { date: '2027-11-01', name: 'Wszystkich Świętych' },
        { date: '2027-11-11', name: 'Święto Niepodległości' },
        { date: '2027-12-24', name: 'Wigilia Bożego Narodzenia' },
        { date: '2027-12-25', name: 'Boże Narodzenie' },
        { date: '2027-12-26', name: 'Drugi dzień Bożego Narodzenia' },
    ],
    2028: [
        { date: '2028-01-01', name: 'Nowy Rok' },
        { date: '2028-01-06', name: 'Trzech Króli' },
        { date: '2028-04-16', name: 'Wielkanoc' },
        { date: '2028-04-17', name: 'Poniedziałek Wielkanocny' },
        { date: '2028-05-01', name: 'Święto Pracy' },
        { date: '2028-05-03', name: 'Konstytucji 3 Maja' },
        { date: '2028-06-04', name: 'Zesłanie Ducha Świętego' },
        { date: '2028-06-15', name: 'Boże Ciało' },
        { date: '2028-08-15', name: 'Wniebowzięcie NMP' },
        { date: '2028-11-01', name: 'Wszystkich Świętych' },
        { date: '2028-11-11', name: 'Święto Niepodległości' },
        { date: '2028-12-24', name: 'Wigilia Bożego Narodzenia' },
        { date: '2028-12-25', name: 'Boże Narodzenie' },
        { date: '2028-12-26', name: 'Drugi dzień Bożego Narodzenia' },
    ],
    2029: [
        { date: '2029-01-01', name: 'Nowy Rok' },
        { date: '2029-01-06', name: 'Trzech Króli' },
        { date: '2029-04-01', name: 'Wielkanoc' },
        { date: '2029-04-02', name: 'Poniedziałek Wielkanocny' },
        { date: '2029-05-01', name: 'Święto Pracy' },
        { date: '2029-05-03', name: 'Konstytucji 3 Maja' },
        { date: '2029-05-20', name: 'Zesłanie Ducha Świętego' },
        { date: '2029-05-31', name: 'Boże Ciało' },
        { date: '2029-08-15', name: 'Wniebowzięcie NMP' },
        { date: '2029-11-01', name: 'Wszystkich Świętych' },
        { date: '2029-11-11', name: 'Święto Niepodległości' },
        { date: '2029-12-24', name: 'Wigilia Bożego Narodzenia' },
        { date: '2029-12-25', name: 'Boże Narodzenie' },
        { date: '2029-12-26', name: 'Drugi dzień Bożego Narodzenia' },
    ],
    2030: [
        { date: '2030-01-01', name: 'Nowy Rok' },
        { date: '2030-01-06', name: 'Trzech Króli' },
        { date: '2030-04-21', name: 'Wielkanoc' },
        { date: '2030-04-22', name: 'Poniedziałek Wielkanocny' },
        { date: '2030-05-01', name: 'Święto Pracy' },
        { date: '2030-05-03', name: 'Konstytucji 3 Maja' },
        { date: '2030-06-09', name: 'Zesłanie Ducha Świętego' },
        { date: '2030-06-20', name: 'Boże Ciało' },
        { date: '2030-08-15', name: 'Wniebowzięcie NMP' },
        { date: '2030-11-01', name: 'Wszystkich Świętych' },
        { date: '2030-11-11', name: 'Święto Niepodległości' },
        { date: '2030-12-24', name: 'Wigilia Bożego Narodzenia' },
        { date: '2030-12-25', name: 'Boże Narodzenie' },
        { date: '2030-12-26', name: 'Drugi dzień Bożego Narodzenia' },
    ],
};
/**
 * Format Date jako 'YYYY-MM-DD' w UTC.
 * Współdzielony helper — reużywany przez monthly-progress service (M6e).
 */
export function formatDateUTC(date) {
    const y = date.getUTCFullYear();
    const m = String(date.getUTCMonth() + 1).padStart(2, '0');
    const d = String(date.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}
export function isPolishHoliday(date) {
    const year = date.getUTCFullYear();
    const iso = formatDateUTC(date);
    return POLISH_HOLIDAYS[year]?.some((h) => h.date === iso) ?? false;
}
export function getPolishHolidayName(date) {
    const year = date.getUTCFullYear();
    const iso = formatDateUTC(date);
    return POLISH_HOLIDAYS[year]?.find((h) => h.date === iso)?.name ?? null;
}
export function isWeekend(date) {
    const day = date.getUTCDay();
    return day === 0 || day === 6;
}
/**
 * Liczy dni robocze w zakresie [startDate, endDate] inclusive.
 * Pomija weekendy i polskie święta państwowe.
 * Daty traktowane jako UTC midnight (zgodnie z @db.Date w Prisma).
 */
export function calculateWorkingDays(startDate, endDate) {
    if (startDate > endDate)
        return 0;
    let count = 0;
    const current = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()));
    const end = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate()));
    while (current.getTime() <= end.getTime()) {
        if (!isWeekend(current) && !isPolishHoliday(current)) {
            count++;
        }
        current.setUTCDate(current.getUTCDate() + 1);
    }
    return count;
}
/**
 * Lista dni roboczych w zakresie — przydatne dla UI (highlight dni urlopowych).
 */
export function listWorkingDaysInRange(startDate, endDate) {
    if (startDate > endDate)
        return [];
    const result = [];
    const current = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()));
    const end = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate()));
    while (current.getTime() <= end.getTime()) {
        if (!isWeekend(current) && !isPolishHoliday(current)) {
            result.push(formatDateUTC(current));
        }
        current.setUTCDate(current.getUTCDate() + 1);
    }
    return result;
}
/**
 * Wymiar czasu pracy dla PEŁNEGO etatu w danym miesiącu (art. 130 Kodeksu pracy).
 *
 * Wzór (równoważny dla miesięcznego okresu rozliczeniowego):
 *   norma = (dni pn-pt w miesiącu × 8h) − (8h × święta w innym dniu niż niedziela)
 *
 * - Święta w niedzielę (np. Wielkanoc, niektóre lata 1 maja) NIE obniżają wymiaru.
 * - Święta w sobotę OBNIŻAJĄ wymiar o 8h (art. 130 § 2 KP) — pracodawca musi udzielić
 *   dnia wolnego w tym samym okresie rozliczeniowym.
 * - Święta pn-pt OBNIŻAJĄ wymiar o 8h.
 *
 * Spodziewane wartości dla 2026:
 *   styczeń: 160, luty: 160, marzec: 176, kwiecień: 168, maj: 160, czerwiec: 168
 *   lipiec: 184, sierpień: 160, wrzesień: 176, październik: 176, listopad: 160, grudzień: 160
 *   Suma: 2008h / 251 dni roboczych.
 *
 * @param year — pełny rok, np. 2026
 * @param month — miesiąc 1-12 (NIE 0-11)
 * @returns liczba godzin pełnego etatu w miesiącu
 */
export function calculateMonthlyNorm(year, month) {
    const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
    let weekdayCount = 0;
    let nonSundayHolidayCount = 0;
    for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(Date.UTC(year, month - 1, day));
        const dow = date.getUTCDay(); // 0=niedziela, 1=pn, ..., 6=sobota
        if (dow >= 1 && dow <= 5)
            weekdayCount++;
        if (isPolishHoliday(date) && dow !== 0)
            nonSundayHolidayCount++;
    }
    return (weekdayCount - nonSundayHolidayCount) * 8;
}
/**
 * Lista polskich świąt w zakresie [startDate, endDate] inclusive — dla UI preview.
 * Zwraca posortowane chronologicznie {date, name}.
 */
export function listHolidaysInRange(startDate, endDate) {
    if (startDate > endDate)
        return [];
    const startIso = formatDateUTC(startDate);
    const endIso = formatDateUTC(endDate);
    const startYear = startDate.getUTCFullYear();
    const endYear = endDate.getUTCFullYear();
    const result = [];
    for (let y = startYear; y <= endYear; y++) {
        const list = POLISH_HOLIDAYS[y];
        if (!list)
            continue;
        for (const h of list) {
            if (h.date >= startIso && h.date <= endIso) {
                result.push(h);
            }
        }
    }
    return result;
}
//# sourceMappingURL=polish-holidays.js.map